
import React, { useEffect, useState } from "react";
import { ALLOWED_DOMAIN } from "../utils/constant";

const allowedDomain = ALLOWED_DOMAIN;
function isAllowedOrigin(origin) {
  try {
    const url = new URL(origin);
    return url.hostname === allowedDomain || url.hostname.endsWith(`.${allowedDomain}`);
  } catch {
    return false;
  }
}

const ProtectedRoute = ({ children }) => {
  const [allowed, setAllowed] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Allow localhost for development
    const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    let referrerOrigin = null;
    if (window.parent !== window && document.referrer) {
      try {
        referrerOrigin = new URL(document.referrer).origin;
      } catch {
        referrerOrigin = null;
      }
    }
    
    if (isDevelopment) {
      setAllowed(true); // Allow direct access in development
    } else if (!referrerOrigin) {
      setAllowed(false);
    } else {
      setAllowed(isAllowedOrigin(referrerOrigin));
    }
    setChecked(true);
  }, []);

  if (!checked) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-50 z-50">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin mx-auto mb-3"></div>
          <span className="text-xl font-medium text-gray-500">Checking Authentication...</span>
        </div>
      </div>
    );
  }
  if (!allowed) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-50 z-50">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-800 mb-3">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to access this page.</p>
          <p className="text-sm text-gray-500 mt-2">Please ensure you are logged in with an authorized account.</p>
        </div>
      </div>
    );
  }
  return children;
};

export default ProtectedRoute;
